import { DisclaimerComponent, RainbowKitProvider } from '@lair-finance/wallet'
import { SERVICE_LINKS } from '@lair-finance/config'

const Disclaimer: DisclaimerComponent = ({ Text, Link }) => (
  <Text>
    By connecting your wallet, you agree to the <Link href={SERVICE_LINKS.TERMS}>Terms of Use</Link> and{' '}
    <Link href={SERVICE_LINKS.PRIVACY}>Privacy Notice</Link> of Lair.fi
  </Text>
)

export function WalletProvider({ children }: { children: React.ReactNode }) {
  return <RainbowKitProvider appInfo={{ disclaimer: Disclaimer }}>{children}</RainbowKitProvider>
}
